import {POST_MESSAGE, MESSAGE_RECEIVED, SET_TARGET_WINDOW} from './constants';

export const postMessageActions = {POST_MESSAGE, MESSAGE_RECEIVED, SET_TARGET_WINDOW};
export {default as createPostMessageBehavior} from './createPostMessageBehavior';
